import { getStaticVisualAssetDefinition, getStaticVisualAssetDefinitions } from './staticManifest';
import { invalidateMapObjectImage } from '../renderer/tilemap/objectImages';
import { invalidateVisualAssetImage } from '../renderer/tilemap/visualAssetImages';

export interface VisualAssetDefinition {
  readonly id: string;
  readonly label: string;
  readonly imagePath: string;
  readonly width?: number;
  readonly height?: number;
  readonly drawScale: number;
  readonly yOffsetTiles: number;
  readonly animated: boolean;
}

const runtimeVisualAssetDefinitions = new Map<string, VisualAssetDefinition>();

export function registerRuntimeVisualAsset(definition: VisualAssetDefinition): void {
  runtimeVisualAssetDefinitions.set(definition.id, definition);
  invalidateVisualAssetImage(definition.id);
  invalidateMapObjectImage(definition.id);
}

export function replaceRuntimeVisualAssets(definitions: readonly VisualAssetDefinition[]): void {
  const previousIds = new Set(runtimeVisualAssetDefinitions.keys());
  runtimeVisualAssetDefinitions.clear();
  for (const definition of definitions) {
    runtimeVisualAssetDefinitions.set(definition.id, definition);
    previousIds.delete(definition.id);
    invalidateVisualAssetImage(definition.id);
    invalidateMapObjectImage(definition.id);
  }
  for (const removedId of previousIds) {
    invalidateVisualAssetImage(removedId);
    invalidateMapObjectImage(removedId);
  }
}

export function unregisterRuntimeVisualAsset(assetId: string): void {
  runtimeVisualAssetDefinitions.delete(assetId);
  invalidateVisualAssetImage(assetId);
  invalidateMapObjectImage(assetId);
}

export function getAllVisualAssetDefinitions(): VisualAssetDefinition[] {
  return [
    ...getStaticVisualAssetDefinitions(),
    ...runtimeVisualAssetDefinitions.values(),
  ];
}

export function getVisualAssetDefinition(assetId: string): VisualAssetDefinition | null {
  return runtimeVisualAssetDefinitions.get(assetId) ?? getStaticVisualAssetDefinition(assetId) ?? null;
}
